import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import isEmpty from '../../../Utilities/is_empty';
import MenuSectionFoodItems from './SectionFoodItems';
import RestaurantDummyLogo from '../SVGs/RestaurantDummyLogo.svg';
import { Menu } from '../../../Interfaces/ReduxInterface/ReduxRootState';
import { Delivery } from '../../../Interfaces/PayloadsAndResponses/Schedules';
// import UserMenuPrefrencesPopup from './UserMenuPrefrencesPopup';
import { getloggedInUser } from '../../../Utilities/getloggedInUser';
import { MarketplaceRef } from '../MarketplacePreview/Marketplace';
import { ApprovedMeetingMenuDetailRef } from '../ApprovedMeetingMenuDetail/ApprovedMeetingMenuDetail';
import { SharedMeetingMenuDetailRef } from '../SharedMeetingMenuDetail/SharedMeetingMenuDetail.tsx';
import { PublicMarketPlaceRef } from '../MarketplacePreview/PublicMarketPlaceWrapper';
import { 
  getMenusOfRestaurant,
  // getMenusOfRestaurantCombos
  } from '../../../Actions/menuActions';
import { useDispatch } from 'react-redux';
// import { useSelector } from 'react-redux';
import { DeliveryMenuRestaurant } from '../../../Interfaces/PayloadsAndResponses/Menu';
import { LocalStorageCompany } from '../../../Interfaces/PayloadsAndResponses/Auth';
import { PublicRestaurantMenuRef } from '../MarketplacePreview/PublicRestaurantMenu';
import MenuDetailPageCarousel from './MenuDetailPageCarousel';
import { Slide } from 'pure-react-carousel';
import Skeleton from 'react-loading-skeleton';
import './menucommon.css'
import useLocalStorage from '../../../Utilities/useLocalStorage';

export type MenuDetailPageParentRef = ApprovedMeetingMenuDetailRef | SharedMeetingMenuDetailRef | MarketplaceRef | PublicMarketPlaceRef | PublicRestaurantMenuRef;

type MenuAreaProps = {
  menu: Menu;
  cutOffPassed?: boolean;
  currentMeeting?: Delivery;
  showCarouselButtons: boolean;
  parentRef: MenuDetailPageParentRef;
  noOfSlidesForUserLiking?: number;
  noOfSlidesForFoodItems: number;
  fromMarketplace?: boolean;
  fromDashboard?: boolean;
  fromInvitedMeeting?: boolean;
  isOpenPopupOnMenuDetailPage?: boolean
  handleMealTypeForMenuCheckAPI?: (value: string) => void;
  handleMealTypeForMenuCheck?: (value: boolean) => void;
  restaurant_id?: number | string;
  mealTypeNumber?: number;
  mealTypeForMenuCheckAPI?: string;
  mealTypeCheckForMenuState?: boolean;
  // menuPageFoodItemPrice?: number;
  // menuPageFoodItemRating?: number;
}
// type MenuRestaurantsFilter = (DeliveryMenuRestaurant | MarketplaceMenuRestaurant) & { selected?: boolean }


export enum MenuSections {
  TopPicks = 'Top Picks',
  DynamicSections = 'Dynamic Sections',
  Favorites = 'Favorites',
  MostPopular = 'Most Popular',
  OrderItAgain = 'Order It Again',
  RestaurentSection = 'Restaurent Section'
}

// const prefrencesModalTimeKey = 'preferencesModalTime'
// const ExpiryHours = 24;
// const PreferencesModalExpiryLimit = ExpiryHours * 60 * 60 * 1000;

const MenuArea = ({
  menu,
  parentRef,
  cutOffPassed = false,
  currentMeeting,
  showCarouselButtons,
  fromDashboard = false,
  fromMarketplace = false,
  fromInvitedMeeting = false,
  noOfSlidesForFoodItems = 0,
  isOpenPopupOnMenuDetailPage = false,
  handleMealTypeForMenuCheckAPI,
  handleMealTypeForMenuCheck,
  restaurant_id,
  mealTypeNumber,
  mealTypeForMenuCheckAPI,
  mealTypeCheckForMenuState,
  // menuPageFoodItemPrice,
  // menuPageFoodItemRating
}: MenuAreaProps) => {

  const { isCompanyAdmin, loggedInUserCompany, loggedInUser } = getloggedInUser();
  // const prefrencesModalTimePresent = useRef(!isEmpty(JSON.parse(localStorage.getItem(prefrencesModalTimeKey) ?? '{}')));
  const { recent_orders_data = null, recent_orders_fooditems = null } = menu?.delivery_recent_orders || {};
  const { delivery_dynamic_sections = null } = menu || {};
  const { top_picks = null, most_popular = null, favorites = null, restaurants = [], } = (fromMarketplace ? menu?.menu_of_restaurant : menu?.menu) || {};

   //Companyname without space
   const companyName = loggedInUserCompany ? loggedInUserCompany?.name?.trim() : '';
   const localStorageCompany = JSON.parse(localStorage.getItem('company') || '{}') as LocalStorageCompany;

  // const getModalRemainingTime = () => {
  //   const currentTime = new Date().getTime();
  //   const prefrencesModalTime = JSON.parse(localStorage.getItem(prefrencesModalTimeKey) ?? '{}');
  //   if (!isEmpty(prefrencesModalTime)) {
  //     if (prefrencesModalTime > currentTime) {
  //       return false
  //     }
  //     else {
  //       localStorage.setItem(prefrencesModalTimeKey, JSON.stringify(currentTime + PreferencesModalExpiryLimit))
  //       return true
  //     }
  //   }
  //   else {
  //     localStorage.setItem(prefrencesModalTimeKey, JSON.stringify(currentTime + PreferencesModalExpiryLimit))
  //     return true
  //   }
  // }

  // Check to ensure that there is minimum a restaurant having a non-empty section
  const sectionsExist = menu && restaurants && restaurants.filter((restaurant) => !isEmpty(restaurant?.sections));
  const isUserPrefrencesSelected = menu && !isEmpty(top_picks) && top_picks && top_picks?.length >= 1;
  const appCueId = `ac-${isCompanyAdmin ? 'admin' : 'user'}-step-${isCompanyAdmin ? '6' : '5'}`
  const isFutureDelivery = !dayjs(currentMeeting?.delivery_at).isBefore(new Date());
  const dispatch: any = useDispatch();
  // const reduxCartAddressIds = useSelector((state: ReduxRootState) => state?.server_cart?.address_ids);
  // const menuRestaurants : MenuRestaurantsFilter[] = restaurants;
  const screenWidth = window.document.body.clientWidth;
  const comboSelected = JSON.parse(localStorage.getItem('combo_selected') || '{}') as any;
  const [sameDayFilterdRestaurants, setSameDayFilteredRestaurants] = useState<DeliveryMenuRestaurant[]>(restaurants)
  // const [sortByRating, setSortByRating] = useState<string>('default')
  const [sortByRatingLoader, setSortByRatingLoader] = useState<boolean>(false)
  const [sortOrder, setSortOrder] = useLocalStorage('sortOrder', 'default');



  useEffect(() => {
    let restantantsToDisplay = []
    let sameDayIsActive = false
    let regularSchedulerActive = false
    let sameDayCutoffForCurrentUser = isCompanyAdmin ? currentMeeting?.sd_admin_cutoff_at : currentMeeting?.sd_cutoff_at


    if (dayjs(currentMeeting?.admin_cutoff_at).isAfter(new Date()) || dayjs(currentMeeting?.cutoff_at).isAfter(new Date())) {
      regularSchedulerActive = true
    }

    if (currentMeeting?.sd_activation_at && dayjs(currentMeeting?.sd_activation_at).isBefore(new Date()) && dayjs(sameDayCutoffForCurrentUser).isAfter(new Date())) {
      sameDayIsActive = true
    }
    if (sameDayIsActive && regularSchedulerActive) {
      restantantsToDisplay = restaurants
    } else if (sameDayIsActive && !regularSchedulerActive) {
      const sameDayFilter = restaurants?.filter((restaurant, id) => {
        return restaurant?.same_day === true
      })
      restantantsToDisplay = sameDayFilter
    } else {
      restantantsToDisplay = restaurants
    }
    setSameDayFilteredRestaurants(restantantsToDisplay)
    // eslint-disable-next-line
  }, [restaurants])


  // const [isOpenPreferencesModal, setIsOpenPreferencesModal] = useState(!isUserPrefrencesSelected && !isOpenPopupOnMenuDetailPage && getModalRemainingTime);

  // useEffect(() => {
  //   if (isOpenPopupOnMenuDetailPage) {
  //     // If Expiry Time was present already then Donot Remove it Otherwise if it was not present but was set by first render then remove it 
  //     !prefrencesModalTimePresent.current && localStorage.removeItem(prefrencesModalTimeKey);
  //     setIsOpenPreferencesModal(false)
  //   }
  // }, [isOpenPopupOnMenuDetailPage])
   
    // Scroll to specific section


  useEffect(() => {
    const dishSectionId = JSON.parse(sessionStorage?.getItem('dish_section') || '{}')
    ScrollToSpecificSection(dishSectionId[0]?.id)
  }, [])

  useEffect(() => {
  }, [mealTypeForMenuCheckAPI])

    const ScrollToSpecificSection = (id: string) => {
      let yOffset:number = 0
      const elementClickForScroll = document.getElementById(id);
      yOffset = -260; // adjust this value to offset for any fixed header you may have
      const ScrollCalculationSpecificElement = elementClickForScroll && elementClickForScroll.getBoundingClientRect();
      const calculatedPositionForScroll = ScrollCalculationSpecificElement?.top && ScrollCalculationSpecificElement?.top + window.pageYOffset + yOffset;
      window.scrollTo({ top: calculatedPositionForScroll || undefined, behavior: 'smooth' });
    };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    let individualBuffetCheck = value === true ? 'buffet' : 'individual'
    handleMealTypeForMenuCheck && handleMealTypeForMenuCheck(!mealTypeCheckForMenuState)
    if (e.target.name === 'mealTypeCheck') {
      handleMealTypeForMenuCheckAPI && handleMealTypeForMenuCheckAPI(individualBuffetCheck)
    }
    // const combo_selected = JSON.parse(localStorage.getItem('combo_selected') || '{}') as any;
    // if (combo_selected?.combo_selected === 'true') {
    //   // const disabledRestaurants = menuRestaurants?.map((restaurant: any) => {
    //   //   return (restaurant?.sections?.length > 0) ? restaurant?.id : ''
    //   // })
    //   // const filteredComboClosedRestaurants: number[] = disabledRestaurants?.filter((id: any) => {
    //   //   return id
    //   // })
    //   // dispatch(getMenusOfRestaurantCombos(reduxCartAddressIds, individualBuffetCheck))
    // }
    else {
      if (typeof restaurant_id !== 'undefined' && typeof mealTypeNumber !== 'undefined') {
        dispatch(getMenusOfRestaurant(+restaurant_id, mealTypeNumber, individualBuffetCheck));
      }
    }
  }

  const handleSortByRating = (value: string) => {
    setSortByRatingLoader(true);
    setTimeout(() => {
      // setSortByRating(value);
      setSortOrder(value)
      setSortByRatingLoader(false); 
    }, 200);
  };

 // Path for favorites Section
 const defaultImagePath = "/imgs/SVGs/favourite.svg";
 const localImagePath = localStorageCompany?.image?.medium?.url;

  const sortingOptions = [
    { label: 'Rating', value: 'rating' },
    { label: 'Price', value: 'price' },
    { label: 'Default', value: 'default' },
  ];
  
  const sortingDropDown = (
    <div>
      <div className="dropdown-menu sort-menu-dropdown border-0 filter-menu-dropdown" style={{ top: '75px' }}>
        {sortingOptions.map((option) => (
          <div key={option.value} className="p-2 dropdown-item dropdown-item-menu">
            <p
              className={`m-0 ml-2  ${sortOrder === option.value ? 'selected-sort-item' : ''}`}
              onClick={() => handleSortByRating(option.value)}
            >
              {option.label}
              <span className="ml-3">{sortOrder === option.value ? '✓' : ''}</span>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
  

  return isEmpty(sectionsExist) ?
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <h1> No items found. </h1>
    </div> :
    <>
      <div className={`d-flex flex-column-reverse flex-lg-row align-items-center pt-4 pb-32 ${(screenWidth > 920 && fromMarketplace) && ' justify-content-between'} sectionScroll ${!fromMarketplace ? 'justify-content-between' : ''}`} >
        <div className="d-flex">
            <div className="d-flex align-items-center">
            {!isEmpty(favorites) && <button className='btn combo-filter-btn d-flex align-items-center mr-3' onClick={() => ScrollToSpecificSection('favorites')}>
              {`${companyName}'s Favorites`}
            </button>}
            {!isEmpty(recent_orders_data) && fromDashboard && <button className='btn combo-filter-btn d-flex align-items-center mr-3' onClick={() => ScrollToSpecificSection('re-order')}>
              Reorder
            </button>}
            {isUserPrefrencesSelected && <button className='btn combo-filter-btn d-flex align-items-center mr-3' onClick={() => ScrollToSpecificSection('top-picks')} >
              Top Picks for You
            </button>}
            {!isEmpty(most_popular) && <button className='btn combo-filter-btn d-flex align-items-center mr-3' onClick={() => ScrollToSpecificSection('most-popular')} >
              Most Popular
            </button>}
          </div>
        {restaurants && <button className='btn combo-filter-btn d-flex align-items-center mr-3' onClick={() => ScrollToSpecificSection('restaurant-menu')} >
          Restaurant(s) Menu
        </button>}
        </div>
        {fromMarketplace && <div className='d-flex justify-center align-items-center'>
          {(!loggedInUserCompany.self_signup && !isEmpty(loggedInUser) && fromMarketplace && !comboSelected.combo_selected && restaurants[0]?.buffet_menu_exists) && <><div className={`custom-control custom-switch pull-right d-inline buffet-menu-switch buffet-menu-button-switch menu-page-menu-type-toggle ${mealTypeCheckForMenuState ? 'buffet-selected' : ''}`}>
            <input type='checkbox' className='custom-control-input buffet-menu-input' id='mealTypeCheck' name='mealTypeCheck'
              checked={mealTypeCheckForMenuState} onChange={onChange}
            />
            <label className='custom-control-label buffet-menu-label buffet-menu-button-switch' htmlFor='mealTypeCheck'>&nbsp;&nbsp;</label>
          </div>
            <button className='btn btn-light my-3' data-toggle='dropdown'><i className='fas fa-chevron-circle-down'></i> Sort By</button>
          </>
          }
          {sortingDropDown}
        </div>}
        <>{(!fromMarketplace || isEmpty(loggedInUser) || (!isEmpty(loggedInUser)  && !restaurants[0]?.buffet_menu_exists)) && <div>
          <button className='btn btn-light my-3' data-toggle='dropdown'><i className='fas fa-chevron-circle-down'></i> Sort By</button>
          {sortingDropDown}
        </div>
        }
        </>
      </div>

      <>
        {sortByRatingLoader ? <>
          {[1, 2].map(section => <React.Fragment key={section}>
            <div className={`d-flex align-items-center`}>
              <div className='mr-2'><Skeleton circle width={66} height={66} /></div>
              <h4 className='m-0'><Skeleton width={120} height={24} /></h4>
            </div>
            <MenuDetailPageCarousel
              totalSlides={5}
              visibleSlides={3}
              showCarouselButtons={false}
            >
              {[1, 2, 3, 4, 5]?.map((fooditem, index) => (
                <Slide className='new-section py-4' key={fooditem} index={index}>
                  <div className={'h-100 mx-2'}>
                    <div className='menu-detail-fooditem-card'>
                      <Skeleton width='100%' height={150} />
                      <div className='p-3 flex-grow-1 bg-white'>
                        <p className='m-0'><Skeleton width='100%' height={25} /></p>
                        <div>
                          <Skeleton width={85} height={20} />
                        </div>
                        <div style={{ color: '#8B9898' }} className='mt-2 card-text d-block text-case'>
                          <Skeleton width='100%' height={30} />
                        </div>
                      </div>
                    </div>
                  </div>
                </Slide>
              ))}
            </MenuDetailPageCarousel>
          </React.Fragment>)}
        </> :
          <>

    {/* Favorites Section */}
     {!isEmpty(favorites) &&
        <>
          <div className='d-flex align-items-center ml-3' id='favorites'>
            {/* <div className='menu-section-icon mr-2 ml-2'>
            <i className='fas fa-heart'></i>
            </div> */}
            <img src={localImagePath ? localImagePath : defaultImagePath} alt="favorites" className='img-square-28'/>
            <h4 className='m-0 ml-3 font-weight-bold'>{`${companyName}'s Favorites`}</h4>
          </div>
          <MenuSectionFoodItems
            cutOffPassed={cutOffPassed}
            currentMeeting={currentMeeting}
            noOfSlidesForFoodItems={noOfSlidesForFoodItems}
            showCarouselButtons={showCarouselButtons}
            parentRef={parentRef}
            fromMarketplace={fromMarketplace}
            sectionType={MenuSections.Favorites}
            fromDashboard={fromDashboard}
            fromInvitedMeeting={fromInvitedMeeting}
            foodItems={favorites ?? []}
            sortedByState={sortOrder}
            // recentOrdersData={recent_orders_data ?? []}
          />
        </> 
        
      }
      {/* Order It Again OR Rate your order Section */}
      {!isEmpty(recent_orders_data) && fromDashboard ?
        <>
          <div className='d-flex align-items-center ml-3' id='re-order'>
            {/* <div className='menu-section-icon mr-2 ml-2'>
              <i className={`${isFutureDelivery ? 'fas fa-redo-alt' : 'fa fa-star-o'}`} aria-hidden='true'></i>
            </div> */}
            <img src="/imgs/SVGs/re-order.svg" alt="Reorder" className='img-square-32' />
            <h4 className='m-0 ml-3 font-weight-bold'>{isFutureDelivery ? 'Reorder' : 'Rate Your Items'}</h4>
          </div>
          <MenuSectionFoodItems
            cutOffPassed={cutOffPassed}
            currentMeeting={currentMeeting}
            noOfSlidesForFoodItems={noOfSlidesForFoodItems}
            showCarouselButtons={showCarouselButtons}
            parentRef={parentRef}
            fromMarketplace={fromMarketplace}
            sectionType={MenuSections.OrderItAgain}
            fromDashboard={fromDashboard}
            fromInvitedMeeting={fromInvitedMeeting}
            foodItems={recent_orders_fooditems ?? []}
            recentOrdersData={recent_orders_data ?? []}
            sortedByState={sortOrder}
          />
        </> :
        ''
      }
      {/* New Section */}
      {isEmpty(top_picks) || (!isUserPrefrencesSelected && cutOffPassed) || fromInvitedMeeting ? '' :
        <>
          {isUserPrefrencesSelected ?
            <div className={`d-flex flex-column flex-sm-row justify-content-between align-items-center w-100`} id='top-picks'>
              <div className='order-2 order-sm-1 w-100'>
                <div className={`d-flex align-items-center pb-2 ml-3`}>
                  {/* <div className='menu-section-icon mr-2 ml-2' id={appCueId}>
                    <i className='fas fa-user'></i>
                  </div> */}
                  <img src="/imgs/SVGs/topPick.svg" alt="Top Picks for You" className='img-square-32' id={appCueId}/>
                  <h4 className='m-0 ml-3 font-weight-bold'> Top Picks for <span className='text-capitalize'>{'you'}</span></h4>
                </div>
              </div>
            </div> : ''}
          {isUserPrefrencesSelected &&
            // ? <UserMenuPrefrencesPopup
            //   isOpen={isOpenPreferencesModal}
            //   closeModal={() => { setIsOpenPreferencesModal(false) }}
            //   currentMeeting={currentMeeting}
            //   fromMarketplace={fromMarketplace}
            //   parentRef={parentRef}
            //   dietaries={top_picks?.dietaries || []}
            // /> :
            <MenuSectionFoodItems
              cutOffPassed={cutOffPassed}
              currentMeeting={currentMeeting}
              noOfSlidesForFoodItems={noOfSlidesForFoodItems}
              showCarouselButtons={showCarouselButtons}
              parentRef={parentRef}
              fromMarketplace={fromMarketplace}
              sectionType={MenuSections.TopPicks}
              fromDashboard={fromDashboard}
              fromInvitedMeeting={fromInvitedMeeting}
              foodItems={top_picks || []}
              sortedByState={sortOrder}
            />
          }
        </>
      }
      {!isEmpty(delivery_dynamic_sections) && !fromMarketplace &&
        <>
          {delivery_dynamic_sections?.dynamic_sections?.map(section =>
            isEmpty(section.fooditems) ? null :
              <React.Fragment key={section.id}>
                <div className='d-flex align-items-center ml-3'>
                  <div className='menu-section-icon mr-2 ml-2'>
                    <i className={`${section.icon ?? 'fas fa-heart'}`}></i>
                  </div>
                  <h4 className='m-0'>{section.name}</h4>
                </div>
                <MenuSectionFoodItems
                  cutOffPassed={cutOffPassed}
                  currentMeeting={currentMeeting}
                  noOfSlidesForFoodItems={noOfSlidesForFoodItems}
                  showCarouselButtons={showCarouselButtons}
                  parentRef={parentRef}
                  sectionType={MenuSections.DynamicSections}
                  fromMarketplace={fromMarketplace}
                  fromDashboard={fromDashboard}
                  fromInvitedMeeting={fromInvitedMeeting}
                  foodItems={section.fooditems || []}
                  sortedByState={sortOrder}
                />
              </React.Fragment>)
          }
        </>
      }
      {/* Most Popular Section */}
      {!isEmpty(most_popular) &&
        <>
          <div className='d-flex align-items-center ml-3' id='most-popular'>
            {/* <div className='menu-section-icon mr-2 ml-2'>
              <i className='fas fa-star'></i>
            </div> */}
             <img src="/imgs/SVGs/Most Popular.svg" alt="popular-restaurant" className='img-square-32' />
            <h4 className='m-0 ml-3 font-weight-bold'>Most Popular</h4>
          </div>
          <MenuSectionFoodItems
            cutOffPassed={cutOffPassed}
            currentMeeting={currentMeeting}
            noOfSlidesForFoodItems={noOfSlidesForFoodItems}
            showCarouselButtons={showCarouselButtons}
            parentRef={parentRef}
            sectionType={MenuSections.MostPopular}
            fromMarketplace={fromMarketplace}
            fromDashboard={fromDashboard}
            fromInvitedMeeting={fromInvitedMeeting}
            foodItems={most_popular || []}
            sortedByState={sortOrder}
          />

        </>
      }
      {/* Delivery Menu Restaurants Section */}
      {sameDayFilterdRestaurants?.map((_restaurants, firstIndex) => {
        return <div key={_restaurants?.id + '-' + firstIndex} style={{ position: 'relative' }} id='restaurant-menu'>
          <div className='row'>
            <div className='col-12 m-auto text-left'>
              {!isEmpty(_restaurants && _restaurants.sections) ? _restaurants.sections && _restaurants.sections.map((section) => {
                let foodItems = section.fooditems;
                return <div id={`${section?.id}`} className={'mainSection' + _restaurants.id + section.id} key={section?.id}>
                  {!isEmpty(section.fooditems) &&
                    <>
                      <div className='d-flex align-items-center ml-3'>
                        {_restaurants.logo_url ?
                          <div className='mr-2 mr-sm-2 menu-restaurant-logo ml-2' style={{ backgroundImage: `url(${_restaurants.logo_url})`, width: 55, height: 55 }}></div> :
                          <img width={55} height={55} src={RestaurantDummyLogo} alt={_restaurants?.name} className='mr-3 rounded-circle' />
                        }
                        <div>
                          <h6 className='d-flex align-items-center restaurent-name m-0 text-capitalize'>{_restaurants.name}</h6>
                          <h4 className='m-0 text-capitalize'>{section?.name}</h4>
                        </div>
                      </div>
                      <MenuSectionFoodItems
                        cutOffPassed={cutOffPassed}
                        currentMeeting={currentMeeting}
                        noOfSlidesForFoodItems={noOfSlidesForFoodItems}
                        showCarouselButtons={showCarouselButtons}
                        sectionType={MenuSections.RestaurentSection}
                        parentRef={parentRef}
                        fromMarketplace={fromMarketplace}
                        fromDashboard={fromDashboard}
                        fromInvitedMeeting={fromInvitedMeeting}
                        foodItems={foodItems}
                        sortedByState={sortOrder}
                      />
                    </>
                  }
                </div>
              }
              ) : ''
              }
            </div>
          </div>
        </div>
      })}
       </>
       }
     </>
    </>
}

export default MenuArea;